// Mock data service to replace backend API calls

// Mock states data
export const mockStates = [
  'Florida',
  'California',
  'Texas',
  'New York',
  'Illinois',
  'Pennsylvania',
  'Ohio',
  'Georgia',
  'North Carolina',
  'Michigan'
];

// Mock counties data by state
export const mockCounties = {
  'Florida': [
    'Broward County',
    'Miami-Dade County',
    'Palm Beach County',
    'Orange County',
    'Hillsborough County',
    'Pinellas County',
    'Duval County',
    'Lee County',
    'Polk County',
    'Brevard County'
  ],
  'California': [
    'Los Angeles County',
    'San Diego County',
    'Orange County',
    'Riverside County',
    'San Bernardino County',
    'Santa Clara County',
    'Alameda County',
    'Sacramento County',
    'Contra Costa County',
    'Fresno County'
  ],
  'Texas': [
    'Harris County',
    'Dallas County',
    'Tarrant County',
    'Bexar County',
    'Travis County',
    'Collin County',
    'Denton County',
    'El Paso County',
    'Fort Bend County',
    'Montgomery County'
  ]
};

// Mock future land use options
export const mockFutureLandUse = {
  'Florida': {
    'Broward County': [
      'Residential Low Density',
      'Residential Medium Density',
      'Residential High Density',
      'Commercial',
      'Industrial',
      'Agricultural',
      'Recreational',
      'Institutional',
      'Mixed Use',
      'Conservation'
    ],
    'Miami-Dade County': [
      'Residential Low Density',
      'Residential Medium Density',
      'Residential High Density',
      'Commercial',
      'Industrial',
      'Agricultural',
      'Recreational',
      'Institutional',
      'Mixed Use',
      'Conservation'
    ]
  },
  'California': {
    'Los Angeles County': [
      'Residential',
      'Commercial',
      'Industrial',
      'Agricultural',
      'Open Space',
      'Mixed Use',
      'Institutional',
      'Recreational'
    ]
  },
  'Texas': {
    'Harris County': [
      'Residential',
      'Commercial',
      'Industrial',
      'Agricultural',
      'Mixed Use',
      'Institutional',
      'Recreational'
    ]
  }
};

// Mock in-place zoning options
export const mockInPlaceZoning = {
  'Florida': {
    'Broward County': [
      'RS-1 (Residential Single Family)',
      'RS-2 (Residential Single Family)',
      'RM-1 (Residential Multi-Family)',
      'RM-2 (Residential Multi-Family)',
      'B-1 (Business)',
      'B-2 (Business)',
      'I-1 (Industrial)',
      'I-2 (Industrial)',
      'A-1 (Agricultural)',
      'PUD (Planned Unit Development)'
    ],
    'Miami-Dade County': [
      'RS-1 (Residential Single Family)',
      'RS-2 (Residential Single Family)',
      'RM-1 (Residential Multi-Family)',
      'RM-2 (Residential Multi-Family)',
      'B-1 (Business)',
      'B-2 (Business)',
      'I-1 (Industrial)',
      'I-2 (Industrial)',
      'A-1 (Agricultural)',
      'PUD (Planned Unit Development)'
    ]
  },
  'California': {
    'Los Angeles County': [
      'R1 (Single Family Residential)',
      'R2 (Two Family Residential)',
      'R3 (Multi-Family Residential)',
      'C1 (Commercial)',
      'C2 (Commercial)',
      'M1 (Light Industrial)',
      'M2 (Heavy Industrial)',
      'A1 (Agricultural)'
    ]
  },
  'Texas': {
    'Harris County': [
      'SF-1 (Single Family)',
      'SF-2 (Single Family)',
      'SF-3 (Single Family)',
      'MF-1 (Multi-Family)',
      'MF-2 (Multi-Family)',
      'LR (Local Retail)',
      'GR (General Retail)',
      'LI (Light Industrial)',
      'HI (Heavy Industrial)',
      'AG (Agricultural)'
    ]
  }
};

// Mock parcels data
export const generateMockParcels = (filters) => {
  const parcels = [];
  const numParcels = Math.floor(Math.random() * 50) + 10; // 10-60 parcels
  
  for (let i = 0; i < numParcels; i++) {
    const parcel = {
      id: `parcel-${i + 1}`,
      parcelNumber: `P${String(i + 1).padStart(6, '0')}`,
      size: parseFloat((Math.random() * 50 + 0.1).toFixed(2)),
      futureLandUse: filters.futureLandUse || 'Residential Low Density',
      currentZoning: filters.inPlaceZoning || 'RS-1 (Residential Single Family)',
      address: `${Math.floor(Math.random() * 9999) + 1} ${['Main St', 'Oak Ave', 'Pine Rd', 'Elm St', 'Maple Dr'][Math.floor(Math.random() * 5)]}`,
      owner: `Owner ${i + 1}`,
      ownerAddress: `${Math.floor(Math.random() * 9999) + 1} Owner St, ${filters.county || 'County'}, ${filters.state || 'State'}`,
      assessedValue: Math.floor(Math.random() * 500000) + 50000,
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1]
        ]]
      }
    };
    
    // Apply filters
    if (filters.minAcreage && parcel.size < parseFloat(filters.minAcreage)) continue;
    if (filters.maxAcreage && parcel.size > parseFloat(filters.maxAcreage)) continue;
    if (filters.maxAssessedValuePerAcre) {
      const valuePerAcre = parcel.assessedValue / parcel.size;
      if (valuePerAcre > parseFloat(filters.maxAssessedValuePerAcre)) continue;
    }
    
    parcels.push(parcel);
  }
  
  return parcels;
};

// Mock assemblages data
export const generateMockAssemblages = (filters) => {
  const assemblages = [];
  const numAssemblages = Math.floor(Math.random() * 20) + 5; // 5-25 assemblages
  
  for (let i = 0; i < numAssemblages; i++) {
    const numParcels = Math.floor(Math.random() * 4) + 2; // 2-5 parcels per assemblage
    const parcels = [];
    let totalSize = 0;
    let totalValue = 0;
    
    for (let j = 0; j < numParcels; j++) {
      const parcelSize = parseFloat((Math.random() * 20 + 0.1).toFixed(2));
      const parcelValue = Math.floor(Math.random() * 300000) + 30000;
      parcels.push({
        parcelNumber: `P${String(i * 10 + j + 1).padStart(6, '0')}`,
        size: parcelSize,
        assessedValue: parcelValue
      });
      totalSize += parcelSize;
      totalValue += parcelValue;
    }
    
    const assemblage = {
      id: `assemblage-${i + 1}`,
      parcelNumbers: parcels.map(p => p.parcelNumber),
      size: parseFloat(totalSize.toFixed(2)),
      numberOfParcels: numParcels,
      futureLandUse: filters.futureLandUse || 'Residential Medium Density',
      currentZoning: filters.inPlaceZoning || 'RM-1 (Residential Multi-Family)',
      addresses: parcels.map((_, index) => `${Math.floor(Math.random() * 9999) + 1} ${['Main St', 'Oak Ave', 'Pine Rd', 'Elm St', 'Maple Dr'][Math.floor(Math.random() * 5)]}`),
      owners: parcels.map((_, index) => `Owner ${i * 10 + index + 1}`),
      ownerAddresses: parcels.map((_, index) => `${Math.floor(Math.random() * 9999) + 1} Owner St, ${filters.county || 'County'}, ${filters.state || 'State'}`),
      assessedValue: totalValue,
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1],
          [-80.1 + Math.random() * 0.1, 26.1 + Math.random() * 0.1]
        ]]
      }
    };
    
    // Apply filters
    if (filters.minAcreage && assemblage.size < parseFloat(filters.minAcreage)) continue;
    if (filters.maxAcreage && assemblage.size > parseFloat(filters.maxAcreage)) continue;
    if (filters.maxAssessedValuePerAcre) {
      const valuePerAcre = assemblage.assessedValue / assemblage.size;
      if (valuePerAcre > parseFloat(filters.maxAssessedValuePerAcre)) continue;
    }
    
    assemblages.push(assemblage);
  }
  
  return assemblages;
};

// Mock API functions
export const mockAPI = {
  // Get states
  getStates: async () => {
    await new Promise(resolve => setTimeout(resolve, 500)); // Simulate network delay
    return mockStates;
  },
  
  // Get counties for a state
  getCounties: async (state) => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return mockCounties[state] || [];
  },
  
  // Get future land use options
  getFutureLandUse: async (state, county) => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockFutureLandUse[state]?.[county] || [];
  },
  
  // Get in-place zoning options
  getInPlaceZoning: async (state, county) => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockInPlaceZoning[state]?.[county] || [];
  },
  
  // Search parcels
  searchParcels: async (filters) => {
    await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate search delay
    
    if (filters.filterType === 'single') {
      return {
        parcels: generateMockParcels(filters),
        assemblages: []
      };
    } else {
      return {
        parcels: [],
        assemblages: generateMockAssemblages(filters)
      };
    }
  }
}; 